import * as React from "react";

import { Trans, withTranslation } from "react-i18next";
import { Tab, Tabs } from "@blueprintjs/core";

import Title from "../Structure/logo";
import IRVEFares from "./IRVEFares";
import IRVEHistory from "./IRVEHistory";

class IRVEMenu extends React.Component {
  render() {
    return (
      <div className="component-body">
        <Title icon="lightning" text={<Trans>IRVE</Trans>} />

        <Tabs
          id="irvemenu"
          fill={true}
          vertical={true}
          renderActiveTabPanelOnly={true}
          defaultSelectedTabId="fm"
        >
          {/* {localStorage.getItem("perm_superadmin") === "true" && ( */}
          <Tab
            id="fm"
            title={<Trans>fare management</Trans>}
            icon="dollar"
            panel={<IRVEFares />}
          />

          <Tab
            id="ch"
            title={<Trans>charging history</Trans>}
            icon="time"
            panel={<IRVEHistory />}
          />
          {/* )} */}
        </Tabs>
      </div>
    );
  }
}

export default withTranslation()(IRVEMenu);
